import SignaturePad from "signature_pad";
import { render_sign } from "../functions";

var ModalCHL = {
    view: function (ctrl, args) {

        return m('div.dm-overlay',
            m("div.dm-table", [
                m("div.dm-cell", [
                    m("div.dm-modal", [
                        m(".bg-primary[style='padding:10px;z-index:1;']", [
                            m("span[id='titleModal']", "Подписать чек-лист"),
                            m("span.pull-right[style='cursor: pointer;']", {
                                onclick: ModalContainerCHL.close
                            }, [
                                m("i.glyphicon.glyphicon-remove"),
                                m.trust('&nbsp;Закрыть')
                            ])
                        ]),
                        [
                            m("div", [
                                m("div[style='margin: 15px 0; padding: 0 15px;']", [
                                    m("div.signature-pad[style='']", [
                                        m("canvas[style='border: 1px solid #000;'][id='canvasSignCheckList']", ""),
                                        m(".row", [
                                            m(".col-xs-6",[
                                                m("button.btn.btn-success.btn-md", {
                                                    id: "yesBtnModalSignCheckList"
                                                }, "Сохранить")
                                            ]),
                                            m(".col-xs-6",[
                                                m("button.btn.btn-info.btn-md", {
                                                    id: "clear_sign",
                                                    onclick: function () {
                                                        var canvas = document.querySelector("canvas");
                                                        if (canvas !== null) {
                                                            var signaturePad = new SignaturePad(canvas, {
                                                                backgroundColor: 'rgb(255, 255, 255)'
                                                            });
                                                            signaturePad.clear();
                                                        }
                                                    }
                                                }, "Очистить")
                                            ])
                                        ]),
                                        m("script", [
                                            m.trust(render_sign())
                                        ])
                                    ]),
                                ])
                            ])
                        ]
                    ])
                ])
            ])
        );
    }
};

export var ModalContainerCHL = {
    container: null,
    idElement: null,
    init: function () {
        ModalContainerCHL.container = document.querySelector('#modalSignCheckList');
        if (!ModalContainerCHL.container) {
            ModalContainerCHL.container = document.createElement('div');
            ModalContainerCHL.container.id = 'modalSignCheckList';
            ModalContainerCHL.container.hidden = true;
            document.body.appendChild(ModalContainerCHL.container);

            m.mount(ModalContainerCHL.container, m.component(ModalCHL, {data:  "", type: false, idElement: ""}));
        }
    },
    open: function (title, idElement) {
        ModalContainerCHL.container = document.querySelector('#modalSignCheckList');
        if(typeof(idElement) != "undefined" && idElement !== null)
            ModalContainerCHL.idElement = idElement;
        if(typeof(removeAll) != "undefined" && removeAll !== null)
            ModalContainerCHL.removeAll = removeAll;

        if (ModalContainerCHL.container) {
            if(title){
                document.getElementById("titleModal").innerText = title;
            }
            //document.getElementById("titleModalSignCheckList").innerText = title;

            ModalContainerCHL.container.hidden = false;
        }
    },
    close: function () {
        let canvas = document.querySelector("canvas");
        if (canvas !== null) {
            let signaturePad = new SignaturePad(canvas, {
                backgroundColor: 'rgb(255, 255, 255)'
            });
            signaturePad.clear();
        }
        ModalContainerCHL.container.hidden = true;
    }
};
